import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ClinicalFocus } from 'components/types/ClinicalFocusTypes';
import { LocationItem } from 'components/types/LocationTypes';

export type Certification = {
  BoardName: {
    value: string;
  };
  SpecialtyName: {
    value: string;
  };
  YearCertified: {
    value: string;
  };
};

export type Training = {
  FieldOfStudy: {
    value: string;
  };
  GraduationYear: {
    value: string;
  };
  TrainingName: {
    value: string;
  };
  TrainingType: {
    value: string;
  };
};

export type ProviderItem = {
  id: string;
  name: string;
  fields: ProviderFields;
};

export type ProviderFields = {
  AboutTheProvider: {
    value: string;
  };
  AcceptingNewPatients: {
    value: string;
  };
  // AgeGroupsSeen: {
  // 	value: string;
  // };
  // AppointmentAvailability: {
  // 	value: string;
  // };
  SortField?: { value?: string };
  BookOnlineOverrideUrl: {
    value: string;
  };
  Certifications: {
    targetItems: Array<Certification>;
  };
  ClinicalFocus: {
    value: Array<ClinicalFocus>;
  };
  // ClinicalKeywords: {
  // 	value: string;
  // };
  Degrees: {
    value: string;
  };
  EpicId: {
    value: string;
  };
  // 'Exclude from Sitemap': {
  // 	value: boolean;
  // };
  ExternalId: {
    value: string;
  };
  // Favicon: {
  // 	value: {};
  // };
  FirstName: {
    value: string;
  };
  FullName: {
    value: string;
  };
  Gender: {
    value: string;
  };
  // 'Include In Right Rail': {
  // 	value: boolean;
  // };
  KSBProvider: {
    value: string;
  };
  LastName: {
    value: string;
  };
  Locations: {
    value: Array<LocationItem>;
  };
  // 'Menu Title': {
  // 	value: string;
  // };
  // MetaDescription: {
  // 	value: string;
  // };
  // MetaKeywords: {
  // 	value: string;
  // };
  NPI: {
  	value: string;
  };
  // NotesText: {
  // 	value: string;
  // };
  OnlineScheduling: {
    value: boolean;
  };
  PersonalInterests: {
    value: string;
  };
  ProviderImage: ImageField;
  Rating: {
    value: number;
  };
  ReviewCount: {
    value: number;
  };
  Reviews: {
    value: string;
  };
  // ShowInPmc: {
  // 	value: string;
  // };
  // 'Sitemap Canonical Url': {
  // 	value: string;
  // };
  // SortField: {
  // 	value: string;
  // };
  Specialty: {
    value: string;
  };
  SpokenLanguages: {
    value: string;
  };
  Trainings: {
    targetItems: Array<Training>;
  };
  VideoUrl: {
    value: string;
  };
  // WebPhoneNumber: {
  // 	value: string;
  // };
};

export type ProviderMetaFields = {
  Degrees: {
    value: string;
  };
  FullName: {
    value: string;
  };
  Locations: {
    value: Array<LocationItem>;
  };
  Specialty: {
    value: string;
  };
  ExternalId: {
    value: string;
  };
  ProviderImage: ImageField;
  SchemaText?: {
    value: string;
  };
};
